import { REPORT_STATE_SELECTOR } from "./utils";
import { API_ROUTES } from "../../../../../system/constants/apiRoutes";
import { REPORT_COLUMNS_KEY, REPORT_DATE_KEY } from "./utils";
import { updateReportFilters } from "./redux/actions";

export const config = {
  columns: [
    "gamer_id",
    "partner_id",
    "project_id",
    "promo_id",
    "tracker_id",
    "sub_id",
    "sub_id2",
    "program_id",
    "reg_ip",
    "country",
    "reg_date",
    "first_deposit_date",
    "qualification_date",
    "first_deposit",
    "deposits",
    "withdraws",
    "bonuses",
    "partner_income",
    "bets",
    "deposits_count",
    "traffic_type_label",
    "login",
    "promo_code",
    "promo_name",
    "project_name",
    "program_name",
    "status_label",
    "role_label",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
    "assured_income",
    "partner_income",
  ],
  hiddenColumns: [],
  subtotals: [
    "first_deposit",
    "deposits",
    "withdraws",
    "bonuses",
    "partner_income",
    "bets",
    "deposits_count",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
    "assured_income",
    "partner_income",
  ],
  filteredColumns: [
    "gamer_id",
    "partner_id",
    "project_id",
    "promo_id",
    "tracker_id",
    "sub_id",
    "sub_id2",
    "program_id",
    "reg_ip",
    "country",
    "reg_date",
    "first_deposit_date",
    "qualification_date",
    "first_deposit",
    "deposits",
    "withdraws",
    "bonuses",
    "partner_income",
    "bets",
    "deposits_count",
    "traffic_type_label",
    "login",
    "promo_code",
    "promo_name",
    "project_name",
    "program_name",
    "status_label",
    "role_label",
    "ngr",
    "ggr",
    "royalty",
    "transaction_commission",
    "rs_income",
  ],
  columnsKey: REPORT_COLUMNS_KEY,
  dateKey: REPORT_DATE_KEY,
  stateSelector: REPORT_STATE_SELECTOR,
  api: API_ROUTES.reports.gamers.path,
  apiKey: API_ROUTES.reports.gamers.key,
  fileName: API_ROUTES.reports.gamers.filename,
  dispatchCallback: updateReportFilters,
};
